// External Dependencies:
import { showLoading, hideLoading } from 'react-redux-loading-bar'

// Internal Dependencies:
import { doRequest } from 'utilities/request'

export function addScript( value ) {
	return {
		type: 'ADD_SCRIPT',
		payload: value
	}
}

export function setCookieConsent( value ) {
	return {
		type: 'SET_COOKIE_CONSENT',
		payload: value
	}
}

export function setOnLineStatus( value ) {
	return {
		type: 'SET_ONLINE_STATUS',
		payload: value
	}
}

export function setConnectionStatus( value ) {
	return {
		type: 'SET_CONNECTION_STATUS',
		payload: value
	}
}

export function openMenu() {
	return {
		type: 'OPEN_MENU'
	}
}

export function closeMenu() {
	return {
		type: 'CLOSE_MENU'
	}
}

export function getPastIssuesData() {
	return function( dispatch, getState ) {
		const { pastIssues } = getState().site

		// Short circuit for existing data:
		if ( Object.keys( pastIssues ).length ) {
			return
		}

		const url = `${siteData.api_base_url}past-issues`

		return doRequest( url, {
			credentials: 'include'
		})
			.then( json => {
				dispatch( receivePastIssuesData( json ) )
			})
			.catch( error => {
				console.log( error, 'error' );
			})
	}
}

export function receivePastIssuesData( json ) {
	return {
		type: 'RECEIVE_PAST_ISSUES_DATA',
		payload: json
	}
}
